<script>
    import AssessmentTypeModel, {importAssessmentType, exportAssessmentType} from './Models/assessmentTypeModel'
    import {forms} from './lib/forms.js';

    import {confirm} from './Components/Confirmation.svelte';
    import {notifier} from "@beyonk/svelte-notifications";

    import Loader from './Components/Loader.svelte';
    import {addFormModal} from './Forms/ModalFormManager.svelte';
    import parseCSV from './lib/csv';
    import SortableTable from './Components/SortableTable.svelte';
    import {tables} from './lib/tables';
    import { isAdmin } from './Utilities/Session.svelte';
    import {handleError} from './Utilities/handlePromise';

    let importing = false;


    let assessmentTypes = AssessmentTypeModel.getAssessmentTypeList();

    function addAssessmentType() {
        addFormModal({
            fields: forms.assessment_type,
            title: "Add Asessment Type",
        }).then((data) => {
            AssessmentTypeModel.createAssessmentType(data);
        }, handleError);
    }

    function importAssessment() {
        addFormModal({
            fields: [{
                type: "text",
                name: "assessment_type_name",
                label: "Assessment Type Name",
                required: true
            }, {
                type: "file",
                name: "import",
                label: "Import File",
                required: true
            }],
            title: "Import Assessment Type"
        }).then(async formData => {
            importing = true;
            formData.import.item(0).text().then((csv) => {
                let rows = parseCSV(csv);

                return importAssessmentType(formData.assessment_type_name, rows);
            }).then(() => {
                importing = false;
            })

            return;
        });
    }

    function export_assessment_type(assessment_type) {
        exportAssessmentType(assessment_type._id).then((csv) => {
            let file = new Blob([csv], {type: 'text/csv'});

            let current_datetime = new Date();
            let formatted_date = current_datetime.getFullYear() + "_" + (current_datetime.getMonth() + 1) + "_" + current_datetime.getDate();

            let url = URL.createObjectURL(file);
            let link = document.createElement("a");
            link.href = url;
            link.download = `export_${assessment_type.name}_${formatted_date}.csv`;
            link.target = "_new";

            link.click();

            URL.revokeObjectURL(url);
        });
    }

    function clone_assessment_type(assessment_type) {
        addFormModal({
            fields: [
                {
                    type: "text",
                    name: "assessment_type_name",
                    label: "Assessment Type Name",
                    required: true
                }
            ],
            title: "Clone Assessment Type"
        }).then((formData) => {
            AssessmentTypeModel.cloneAssessmentType(assessment_type, formData.assessment_type_name).then(() => {
                notifier.success("Assessment Type Cloned");
            });
        })
    }

    function deleteAssessmentType(assessment_type) {
        confirm(`Are you sure you want to delete "${assessment_type.name}?" This cannot be undone.`).then(() => {
            AssessmentTypeModel.deleteAssessmentType(assessment_type);
        }).catch(()=> null);
    }
</script>

<Loader loading={!$assessmentTypes}>
    <div class="container is-fluid">
        <h1 class="title is-1">Assessment Types</h1>

        <SortableTable sortFields={tables['assessmentTypeList']} tableData={$assessmentTypes} actionsWidth="300" showHideFields={false}>
            <div class="buttons is-right" slot="rowActions" let:row={type}>
                {#if $isAdmin}
                    <button class="button" on:click={() => clone_assessment_type(type)}>Clone</button>
                    <button class="button" on:click={() => export_assessment_type(type)}>Export</button>
                {/if}
                <button class="button is-danger" on:click={() => deleteAssessmentType(type)}>Delete</button>
                <a class="button is-link" href="#/assessmentTypes/{type._id}">Edit</a>
            </div>
            <div slot="footerActions">
                {#if $isAdmin}
                    <button class="button is-info is-pulled-left" on:click={importAssessment}>
                        Import Assessment
                    </button>
                {/if}
                <div class="buttons is-right">
                    <button class="button is-success is-right" on:click={addAssessmentType}>Create New Assessment Type</button>
                </div>
            </div>
            <div slot="filterActions">
                <div class="buttons is-centered">
                    <button class="button is-success is-right" on:click={addAssessmentType}>Create New Assessment Type</button>
                </div>
            </div>
        </SortableTable>
    </div>
</Loader>

<Loader loading={importing} />

<style>
    .container {
        padding-left: 32px;
        padding-right: 32px;
    }
</style>